// set opacity to the overlay, so that content under blocker is still visible.
export const customizedUIBlockerStyle = {
  '& .react-block-ui > div:last-child': {
    backgroundColor: 'rgba(255, 255, 255, 0.4) !important',

    '& div[class*=blockerIndicator]': {
      display: 'inline-flex',
      alignItems: 'end',
    },
  },
};
